import { combineReducers } from 'redux'
import configureStore from './CreateStore'
import rootSaga from '../Sagas'

// Import reducers
import { reducer as authReducer } from './AuthRedux'
import { reducer as scriptReducer } from './ScriptRedux'
import { reducer as audioReducer } from './AudioRedux'
import { reducer as videoReducer } from './VideoRedux'
import { reducer as thumbnailReducer } from './ThumbnailRedux'
import { reducer as draftReducer } from './DraftRedux'
import { reducer as voiceReducer } from './VoiceRedux'
import { reducer as soundEffectReducer } from './SoundEffectRedux'
import { reducer as creditReducer } from './CreditRedux'
import { reducer as plansReducer } from './PlansRedux'
import { reducer as subtitleReducer } from './SubtitleRedux'
import { reducer as publicationReducer } from './PublicationRedux'

/* ------------- Combine All Reducers ------------- */
export const reducers = combineReducers({
  auth: authReducer,
  script: scriptReducer,
  audio: audioReducer,
  video: videoReducer,
  thumbnail: thumbnailReducer,
  draft: draftReducer,
  voice: voiceReducer,
  soundEffect: soundEffectReducer,
  credits: creditReducer,
  plans: plansReducer,
  subtitle: subtitleReducer,
  publication: publicationReducer,
})

/* ------------- Create Store ------------- */
let sagasManager
let sagaMiddleware

export default function createReduxStore() {
  const config = configureStore(reducers, rootSaga)
  sagasManager = config.sagasManager
  sagaMiddleware = config.sagaMiddleware

  // Hot Module Replacement for reducers
  if (import.meta.hot) {
    import.meta.hot.accept(
      [
        './AuthRedux',
        './ScriptRedux',
        './AudioRedux',
        './VideoRedux',
        './ThumbnailRedux',
        './DraftRedux',
        './VoiceRedux',
        './SoundEffectRedux',
        './CreditRedux',
        './PlansRedux',
        './SubtitleRedux',
        './PublicationRedux',
      ],
      async (modules) => {
        // Dynamic imports for HMR in ES modules
        const [
          AuthRedux,
          ScriptRedux,
          AudioRedux,
          VideoRedux,
          ThumbnailRedux,
          DraftRedux,
          VoiceRedux,
          SoundEffectRedux,
          CreditRedux,
          PlansRedux,
          SubtitleRedux,
          PublicationRedux,
        ] = await Promise.all([
          import('./AuthRedux'),
          import('./ScriptRedux'),
          import('./AudioRedux'),
          import('./VideoRedux'),
          import('./ThumbnailRedux'),
          import('./DraftRedux'),
          import('./VoiceRedux'),
          import('./SoundEffectRedux'),
          import('./CreditRedux'),
          import('./PlansRedux'),
          import('./SubtitleRedux'),
          import('./PublicationRedux'),
        ])
        
        const nextReducers = combineReducers({
          auth: AuthRedux.reducer,
          script: ScriptRedux.reducer,
          audio: AudioRedux.reducer,
          video: VideoRedux.reducer,
          thumbnail: ThumbnailRedux.reducer,
          draft: DraftRedux.reducer,
          voice: VoiceRedux.reducer,
          soundEffect: SoundEffectRedux.reducer,
          credits: CreditRedux.reducer,
          plans: PlansRedux.reducer,
          subtitle: SubtitleRedux.reducer,
          publication: PublicationRedux.reducer,
        })
        config.store.replaceReducer(nextReducers)
      }
    )

    import.meta.hot.accept('../Sagas', async () => {
      const SagasModule = await import('../Sagas')
      sagasManager.cancel()
      sagasManager = sagaMiddleware.run(SagasModule.default)
    })
  }

  return config
}

// Export store singleton
const storeConfig = createReduxStore()
export const store = storeConfig.store
